module.exports = __webpack_public_path__ + "static/yg-desk-380149da6db04245f72720e6d06e51f8.png";